import { render, staticRenderFns } from "./handicapExchange.vue?vue&type=template&id=b3cbd846&scoped=true"
import script from "./handicapExchange.vue?vue&type=script&lang=js"
export * from "./handicapExchange.vue?vue&type=script&lang=js"
import style0 from "./handicapExchange.vue?vue&type=style&index=0&id=b3cbd846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cbd846",
  null
  
)

export default component.exports